module.exports = __webpack_public_path__ + "static/Story-cc4023b3c7cf125029c2a8a9d8d1c50c.jpg";